import { LEGAL_DOC_VERSIONS, type LegalDocType } from "./legal-versions";

const CONSENT_STORAGE_KEY = "plateOS_legal_consent";

export interface StoredConsent {
  acceptedAt: string;
  versions: Record<LegalDocType, string>;
}

export function readStoredConsent(): StoredConsent | null {
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredConsent;
    if (
      parsed?.versions?.privacy === LEGAL_DOC_VERSIONS.privacy &&
      parsed?.versions?.terms === LEGAL_DOC_VERSIONS.terms &&
      parsed?.versions?.disclaimer === LEGAL_DOC_VERSIONS.disclaimer
    ) {
      return parsed;
    }
    return null;
  } catch {
    return null;
  }
}

export function storeConsent(): StoredConsent {
  const consent: StoredConsent = {
    acceptedAt: new Date().toISOString(),
    versions: { ...LEGAL_DOC_VERSIONS },
  };
  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(consent));
  } catch {}
  return consent;
}

export function clearStoredConsent(): void {
  try {
    localStorage.removeItem(CONSENT_STORAGE_KEY);
  } catch {}
}
